import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the layout class to inform that the layout should initialize with
 * showGridLines = true when no initial value is provided by the user to DashboardContext
 * @param {Layout} Layout The layout to enhance
 * @param {Object} [arg1] Optional configuration
 * @param {boolean} [arg1.value=true] The initialShowGrid value for the layout
 */
export const withInitialShowGrid: PresetHOC<
    {
        initialShowGrid?: boolean;
    },
    { value?: boolean }
> = (Layout, { value = true } = {}) => {
    Layout.initialShowGrid = value;

    return Layout;
};
